:host {
  display: block;
  justify-content: center;
  align-items: center;
}

.container {
display: contents;
}

.outer-circle {
  width: 100%; /* 40% of screen with, responsive design */
  aspect-ratio: 1 / 1; /* 1:1 aspect ratio */
  //height: 40vw;
  border-radius: 50%;
  display: flex;
  align-items: center;
}

.middle-circle {
  width: 90%; /* size depends on outer-circle */
  height: 90%;
  border-radius: 50%;
  display: flex;
  align-items: center;
  transform: translateY(-2%)
}

.inner-circle {
  width: 88%;
  height: 88%;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  transform: translateY(-1%);
  background-color: #ffffff
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}